import {
  boosterPlanIdAU,
  boosterPlanIdCA,
  boosterPlanIdEU,
  boosterPlanIdGB,
  boosterPlanIdUS,
  boosterPlanIdUSMedium,
  businessPlanIdAU,
  businessPlanIdCA,
  businessPlanIdEU,
  businessPlanIdGB,
  businessPlanIdUS,
  businessPlanIdUSDMedium,
  familyPlanIdAU,
  familyPlanIdCA,
  familyPlanIdEU,
  familyPlanIdGB,
  familyPlanIdUS,
  familyPlanIdUSMedium,
  megaPlanIdAU,
  megaPlanIdCA,
  megaPlanIdEU,
  megaPlanIdGB,
  megaPlanIdUS,
  megaPlanIdUSMedium,
  personalPlanIdAU,
  personalPlanIdCA,
  personalPlanIdEU,
  personalPlanIdGB,
  personalPlanIdUS,
  personalPlanIdUSMedium,
} from './plans';

export const plansForCurrency = {
  GBP: {
    personal: {
      current: personalPlanIdGB,
    },
    booster: {
      current: boosterPlanIdGB,
    },
    mega: {
      current: megaPlanIdGB,
    },
    business: {
      current: businessPlanIdGB,
    },
    family: {
      current: familyPlanIdGB,
    },
  },
  USD: {
    personal: {
      current: personalPlanIdUS,
    },
    booster: {
      current: boosterPlanIdUS,
    },
    mega: {
      current: megaPlanIdUS,
    },
    business: {
      current: businessPlanIdUS,
    },
    family: {
      current: familyPlanIdUS,
    },
  },
  EUR: {
    personal: {
      current: personalPlanIdEU,
    },
    booster: {
      current: boosterPlanIdEU,
    },
    mega: {
      current: megaPlanIdEU,
    },
    business: {
      current: businessPlanIdEU,
    },
    family: {
      current: familyPlanIdEU,
    },
  },
  AUD: {
    personal: {
      current: personalPlanIdAU,
    },
    booster: {
      current: boosterPlanIdAU,
    },
    mega: {
      current: megaPlanIdAU,
    },
    business: {
      current: businessPlanIdAU,
    },
    family: {
      current: familyPlanIdAU,
    },
  },
  CAD: {
    personal: {
      current: personalPlanIdCA,
    },
    booster: {
      current: boosterPlanIdCA,
    },
    mega: {
      current: megaPlanIdCA,
    },
    business: {
      current: businessPlanIdCA,
    },
    family: {
      current: familyPlanIdCA,
    },
  },
};

export const plansForUSMedium = {
  personal: {
    current: personalPlanIdUSMedium,
  },
  booster: {
    current: boosterPlanIdUSMedium,
  },
  mega: {
    current: megaPlanIdUSMedium,
  },
  business: {
    current: businessPlanIdUSDMedium,
  },
  family: {
    current: familyPlanIdUSMedium,
  },
};
